"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.UserNotPermittedError = exports.AssignmentDoesNotExistError = exports.AssignmentBodyNotValidError = exports.AssignmentBadRequestError = void 0;
const AssignmentBadRequestError_1 = __importDefault(require("./errors/AssignmentBadRequestError"));
exports.AssignmentBadRequestError = AssignmentBadRequestError_1.default;
const AssignmentBodyNotValidError_1 = __importDefault(require("./errors/AssignmentBodyNotValidError"));
exports.AssignmentBodyNotValidError = AssignmentBodyNotValidError_1.default;
const AssignmentDoesNotExistError_1 = __importDefault(require("./errors/AssignmentDoesNotExistError"));
exports.AssignmentDoesNotExistError = AssignmentDoesNotExistError_1.default;
const UserNotPermittedError_1 = __importDefault(require("./errors/UserNotPermittedError"));
exports.UserNotPermittedError = UserNotPermittedError_1.default;
var AssignmentsServiceClient_1 = require("./AssignmentsServiceClient");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(AssignmentsServiceClient_1).default; } });
//# sourceMappingURL=index.js.map